import { render, staticRenderFns } from "./TeamTimeOffMain.vue?vue&type=template&id=a274b888"
import script from "./TeamTimeOffMain.vue?vue&type=script&lang=js"
export * from "./TeamTimeOffMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports